import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import uniqid from 'uniqid';

import { api_crud_base, api_list_route, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../../UseToken';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';
import { color } from '../../../WEBContent/Color';
import { icon } from '../../../WEBContent/Icon';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	translate,
	functionSendMail,
} from '../../../../Utils';

import Hosts, { companycode } from '../../../../Hosts';
import { renderScrollShim } from '@fullcalendar/core/internal';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const entities_list = useRef(null);
	const active = useRef(null);
	const active_raw = useRef(null);
	const repair_type = useRef(null);
	const periodicity = useRef(null);
	const maintenance_orders = useRef(null);

	const year_active = useRef(null);
	const years_actives = useRef(null);

	const [lang, set_lang] = useState('pt');
	const [uid,] = useState(uniqid());

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)
	const [treeDataPDF, setTreeDataPDF] = useState([])
	const [treeDataEditable, setTreeDataEditable] = useState([])

	const [files_doc_pdf, set_files_doc_pdf] = useState([]);
	const [files_doc_pdf_name, set_files_doc_pdf_name] = useState([]);
	const [files_doc_editable, set_files_doc_editable] = useState([]);
	const [files_doc_editable_name, set_files_doc_editable_name] = useState([]);

	const [treeDataImage, setTreeDataImage] = useState([])
	const [files_doc_image, set_files_doc_image] = useState([]);
	const [files_doc_image_name, set_files_doc_image_name] = useState([]);

	const [notify_responsable_edit, set_notify_responsable_edit] = useState(false)
	const [notify_responsable_aproval, set_notify_responsable_aproval] = useState(false)
	const [notify_responsable_remove, set_notify_responsable_remove] = useState(false)

	const [update, setUpdate] = useState(0);
	const [editingItem, setEditingItem] = useState(null);

	const [isEditing, setIsEditing] = useState(false);
	const [editItemId, setEditItemId] = useState('');
	const [modal, setModal] = useState(false);
	const [document_state_list, set_document_state_list] = useState([])
	const [document_state_aprove, set_document_state_aprove] = useState(false)
	const [selectedEquipment, setSelectedEquipment] = useState(null);
	const [manutencao, setManutencao] = useState(null); //TRUE = 'Manutenção', FALSE = 'Reparação', NULL = 'Nenhum'
	const [externalIntervention, setExternalIntervention] = useState('');
	const [filterYear, setFilterYear] = useState('');
	const [filterMonth, setFilterMonth] = useState('');

	const tableStyle = {
		borderCollapse: 'collapse',
		color: color.cor1.hexa,
		textAlign: 'left',
		boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
		borderRadius: '8px',
		overflow: 'hidden',
		backgroundColor: color.cor3.hexa,
	};

	const headerCellStyle = {
		padding: '12px 15px',
		textAlign: 'center',
		color: color.cor3.hexa,
		fontWeight: '600',
		borderBottom: '2px solid #ddd',
		backgroundColor: color.corLaranja.rgb3,
		textTransform: 'uppercase',
	};

	const cellStyle = {
		borderBottom: `1px solid rgb(${color.cor3.rgb})`,
		textAlign: 'center',
		verticalAlign: 'middle',
		padding: '12px 15px',
		color: color.corCinza.hexa,
		lineHeight: '1.6',
		backgroundColor: color.cor3.hexa,
	};

	const rowStyle = {
		fontSize: '14px',
		backgroundColor: color.cor3.hexa,
		transition: 'background-color 0.3s ease',
	};

	const filterContainerStyle = {
		display: 'flex',
		gap: '12px',
		marginBottom: '20px',
		flexWrap: 'wrap',
		alignItems: 'flex-end',
	};

	const filterItemStyle = {
		flex: '1 1 160px',
		display: 'flex',
		flexDirection: 'column',
	};

	const filterLabelStyle = {
		marginBottom: '4px',
		color: color.cor1.hexa,
		fontWeight: '500',
	};

	const filterSelectStyle = {
		padding: '6px 10px',
		border: `1px solid ${color.corCinza.hexa}`,
		borderRadius: '4px',
		backgroundColor: color.cor3.hexa,
		color: color.cor1.hexa,
	};

	const maxWidthStyle = {
		maxWidth: '120px',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap'
	};

	const MONTH_NAMES = [
		language[lang].janeiro,
		language[lang].fevereiro,
		language[lang].marco,
		language[lang].abril,
		language[lang].maio,
		language[lang].junho,
		language[lang].julho,
		language[lang].agosto,
		language[lang].setembro,
		language[lang].outubro,
		language[lang].novembro,
		language[lang].dezembro
	];

	const selectedMonthName = filterMonth ? MONTH_NAMES[parseInt(filterMonth) - 1] : '';

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	const fetch_entities_list = async () => {

		let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
		let result = []
		if (res.data !== undefined) {
			result = res.data.filter(el => parseInt(el.entity_type) === parseInt('1'))
		}

		return result

	}

	const fetch_maintenance_actives = async (type) => {

		let res = await reqGET(`${api_crud_base}/intranet/maintenance/type/${getTokenInfo().companycode}/${type}`)
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {
				//console.log('el', el)
				let aux = {
					id: el.id,
					name: translate(el.info.title, 'pt'),

					cod: el.info.tag,
					brand: el.info.settings.storage_brand,
					model: el.info.settings.storage_model,
					serie: el.info.settings.storage_serie,
					local: el.info.settings.storage_local,
				}

				result.push(aux)
			}
		}

		return result

	}

	const get_info = async (id_eq) => {
		await reqGET(api_list_route(getTokenInfo().companycode))
			.then(async res => {
				if (res.data[0] !== undefined) {

					if(Array.isArray(res.data) && res.data.length > 0) {
						// set_maintenance_orders(res.data);

						console.log('res.data', res.data)
						console.log('id_eq', id_eq)

						let array_aux = []
						let array_ano_aux = []
						for await (let el of res.data) {
							console.log('el.info.equipment.id', el.info.equipment.id)
							if (parseInt(el.info.equipment.id) === parseInt(id_eq)) {
								array_aux.push(el)

								if(el?.info?.settings?.data_inicio !== undefined && el?.info?.settings?.data_inicio !== null && el.info.settings.data_inicio !== '') {
									let aux_data = el.info.settings.data_inicio.split('-')
									let aux_2 = array_ano_aux.filter(e1 => parseInt(e1) === parseInt(aux_data[0]))
									if(Array.isArray(aux_2) && aux_2.length === 0) {
										array_ano_aux.push(aux_data[0])
									}
								}
							}

						}

						set_dados(maintenance_orders.current = array_aux);
						set_dados(years_actives.current = array_ano_aux)
						set_dados(year_active.current = years_actives.current[0])
					}


					// console.log('maintenance_orders.current', maintenance_orders.current)
					// console.log('years_actives.current', years_actives.current)
					// console.log('year_active.current', year_active.current)

				}


			})
			.catch(() => 404
			)
	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

	useEffect(() => {
		clean_data();

		const currentYear = new Date().getFullYear();
		setFilterYear(String(currentYear));

		set_lang(localStorage.getItem('lang'))

		set_dados(entities_list.current = [])
		set_dados(active.current = [])

		let aux_document_state = [
			{
				id: 0,
				label: 'Em edição'
			},
			{
				id: 1,
				label: 'Aguarda aprovação'
			},
			{
				id: 2,
				label: 'Em revisão'
			},
			{
				id: 3,
				label: 'Aprovado'
			},
			{
				id: 4,
				label: 'Obsoleto'
			},
			{
				id: 5,
				label: 'Eliminado'
			}
		]
		set_document_state_list(aux_document_state)

		const fetch_maintenance_attributes = async (type) => {

			let res = await reqGET(`${api_crud_base}/intranet/maintenance/attribute/type/${getTokenInfo().companycode}/${type}`)
			let result = []
			if (res.data !== undefined) {
				for await (let el of res.data) {

					let aux = {
						id: el.id,
						name: translate(el.info.title, 'pt')
					}

					result.push(aux)
				}
			}

			return result

		}

		const get_attr = async () => {

			let res_2 = await fetch_maintenance_attributes('repair_type')
			if (res_2.length > 0) {
				res_2 = order_array(res_2)

				let res_aux_2 = []
				for await (let el of res_2) {
					res_aux_2.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(repair_type.current = res_aux_2)
			}

			let res_1 = await fetch_maintenance_actives('active')
			if (res_1.length > 0) {
				res_1 = order_array(res_1)

				let res_aux_1 = []
				for await (let el of res_1) {
					res_aux_1.push({
						id: el.id,
						label: el.name,
						cod: el.cod,
					})
				}
				set_dados(active.current = res_aux_1)
				set_dados(active_raw.current = res_1)

				if (dados.current.info?.equipment?.id !== undefined && dados.current.info.equipment.id !== null && dados.current.info.equipment.id !== '') {
					const selected = res_1?.find(el => parseInt(el.id) === parseInt(dados.current.info.equipment.id))
					setSelectedEquipment(selected || null);
				}
			}

			let res_4 = await fetch_entities_list()
			if (res_4.length > 0) {
				res_4 = order_array(res_4)

				let res_aux_4 = []
				for await (let el of res_4) {
					res_aux_4.push({
						id: el.id,
						label: el.name,
						email: el.email
					})
				}
				set_dados(entities_list.current = res_aux_4)
			}
			let res_3 = await fetch_maintenance_attributes('periodicity')
			if (res_3.length > 0) {
				res_3 = order_array(res_3)

				let res_aux_3 = []
				for await (let el of res_3) {
					res_aux_3.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(periodicity.current = res_aux_3)
			}

			setLoading(false);

			return true

		}

		const fetch_id_info = async (id_serch) => {

			await get_attr()

			try {

				let res = await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
				set_dados(dados.current = res.data[0]);
				let array_ano_aux = []
				if (Array.isArray(res.data) && res.data.length > 0) {
					if (res.data[0]?.info?.file?.pdf !== undefined && Array.isArray(res.data[0].info.file.pdf)) {
						let aux_doc_pdf = []
						let i = 0

						for await (let el of res.data[0].info.file.pdf) {
							if (aux_doc_pdf[0] === undefined)
								aux_doc_pdf[0] = []
							if (aux_doc_pdf[0][1] === undefined)
								aux_doc_pdf[0][1] = []

							// aux_doc_pdf[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_pdf[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataPDF(aux_doc_pdf)
					}
					if (res.data[0]?.info?.file?.editable !== undefined && Array.isArray(res.data[0].info.file.editable)) {
						let aux_doc_editable = []
						let i = 0

						for await (let el of res.data[0].info.file.editable) {
							if (aux_doc_editable[0] === undefined)
								aux_doc_editable[0] = []
							if (aux_doc_editable[0][1] === undefined)
								aux_doc_editable[0][1] = []

							// aux_doc_editable[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_editable[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataEditable(aux_doc_editable)
					}
					if (res.data[0]?.info?.file?.file_image !== undefined && Array.isArray(res.data[0].info.file.file_image)) {
						let aux_doc_image = []
						let i = 0

						for await (let el of res.data[0].info.file.file_image) {
							if (aux_doc_image[0] === undefined)
								aux_doc_image[0] = []
							if (aux_doc_image[0][1] === undefined)
								aux_doc_image[0][1] = []

							aux_doc_image[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							// aux_doc_image[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataImage(aux_doc_image)
					}
					
					const equipment = res.data[0].info?.equipment || '';

					if (equipment?.id != null && equipment.id !== '') {
						const selected = active_raw.current?.find(
							el => parseInt(el.id) === parseInt(equipment.id)
						);
						setSelectedEquipment(selected || null);
					}

					/*
					if (res.data[0] !== undefined && res.data[0] !== null && res.data[0] !== '') {
						const selected = active_raw.current?.find(el => parseInt(el.id) === parseInt(res.data[0].id))
						setSelectedEquipment(selected || null);

					}
					*/
				}

				set_is_edit(true)

				get_info(id_serch)

			} catch (error) {
				console.error("Erro:", error);
			}
		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				fetch_id_info(props.location.state.item.id)
			}
			else {
				get_attr()
			}

		} catch {
			clean_data()

			get_attr()

			return
		}


	}, [props, active_raw]);

	const handleSubmit = async e => {
		e.preventDefault();

		let today = new Date();
		let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

		if (is_edit === true) {

			await Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						if (document_state_aprove) {
							dados.current.info.settings.document_state = "3"

							dados.current.info.responsable.aproval.execution = today
							dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = today
						}

						if (notify_responsable_edit) {
							if (dados.current.info.responsable.edit.id !== '') {
								let aux_id = dados.current.info.responsable.edit.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.edit.notification = today
								dados.current.info.responsable.edit.execution = today

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})

									dados.current.info.responsable.aproval.id = ''
									dados.current.info.responsable.aproval.name = ''
									dados.current.info.responsable.aproval.notification = ''
									dados.current.info.responsable.aproval.execution = ''
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
									}
									else {
										dados.current.info.historic.push({
											edit: {
												id: aux_responsable[0].id,
												name: aux_responsable[0].label,
												date: today
											},
											aproval: {
												id: '',
												name: '',
												date: ''
											}
										})

										dados.current.info.settings.document_state = "1"

										dados.current.info.responsable.aproval.id = ''
										dados.current.info.responsable.aproval.name = ''
										dados.current.info.responsable.aproval.notification = ''
										dados.current.info.responsable.aproval.execution = ''
									}
								}
							}
						}

						if (notify_responsable_aproval) {
							if (dados.current.info.responsable.aproval.id !== '') {
								let aux_id = dados.current.info.responsable.aproval.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.aproval.notification = today

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

								}
							}
						}

						if (notify_responsable_remove) {
							if (dados.current.info.responsable.remove.id !== '') {

								dados.current.info.responsable.remove.notification = today
								dados.current.info.responsable.remove.execution = today

							}

						}

						await reqPUT(api_crud_route, maintenance_orders.current)
							.then(async () => {
								if (notify_responsable_edit) {

								}
								if (notify_responsable_aproval) {
									if (dados.current.info.responsable.aproval.id !== '') {

										let aux_id = dados.current.info.responsable.aproval.id
										let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

										if (Array.isArray(aux_responsable) && aux_responsable.length > 0) {

											let aux = {
												id: dados.current.id,
												uniqid: dados.current.info.uniqid,
												companycode: dados.current.info.companycode,

												type: 'maintenance',
												title: translate(dados.current.info.title, lang),
												description: translate(dados.current.info.description, lang),
												responsaveis: [{
													value: aux_responsable[0].id
												}],
												state_object: {
													value: 1,
													labelEn: "Pending approval",
													labelPt: "Pendente de aprovação"
												},
												deadline: '',
											}

											reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)

											return

											let mail_content = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + '; border:1px solid transparent; border-collapse:collapse;">' +
												'<tr style="border-collapse: collapse;">' +
												'<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<span><b>' + language[lang].notification_aproval_subject + '</b></span>' +
												'</div>' +
												'</td>' +
												'<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<span>' + today_aux + '</span>' +
												'</div>' +
												'</td>' +
												'</tr>' +

												'<tr>' +
												'<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
												'</tr>' +

												'<tr style="border-collapse: collapse;">' +
												'<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<br/>' +
												'<span>' + language[lang].notification_aproval_text + '</span>' +
												'<br/>' +
												'</div>' +
												'</td>' +
												'</tr>' +
												'</table>'

											// let sendFrom = 'web.dev@assec.pt'
											// let sendTo = ['web.teste@assec.pt']
											// let sendToCC = ['web.dev@assec.pt']
											// let subject = language[lang].notification_aproval_subject
											// let content = mail_content
											// let attachment = []

											// await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment)
										}

									}
								}
								if (notify_responsable_remove) {
									if (dados.current.info.responsable.remove.id !== '') {
										// let aux_id = dados.current.info.responsable.remove.id
										// let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

										// console.log('remove aux_responsable', aux_responsable)
										dados.current.info.responsable.remove.notification = today
									}
								}

							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

		}
		else {

			await Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						dados.current.info['uniqid'] = uid

						if (notify_responsable_edit) {
							if (dados.current.info.responsable.edit.id !== '') {
								let aux_id = dados.current.info.responsable.edit.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.edit.notification = today
								dados.current.info.responsable.edit.execution = today

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})

									// dados.current.info.responsable.aproval.id = ''
									// dados.current.info.responsable.aproval.name = ''
									// dados.current.info.responsable.aproval.notification = ''
									// dados.current.info.responsable.aproval.execution = ''
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
									}
									else {
										dados.current.info.historic.push({
											edit: {
												id: aux_responsable[0].id,
												name: aux_responsable[0].label,
												date: today
											},
											aproval: {
												id: '',
												name: '',
												date: ''
											}
										})

										dados.current.info.settings.document_state = "1"

										// dados.current.info.responsable.aproval.id = ''
										// dados.current.info.responsable.aproval.name = ''
										// dados.current.info.responsable.aproval.notification = ''
										// dados.current.info.responsable.aproval.execution = ''
									}
								}
							}
						}

						if (notify_responsable_aproval) {
							if (dados.current.info.responsable.aproval.id !== '') {
								let aux_id = dados.current.info.responsable.aproval.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.aproval.notification = today

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

								}
							}
						}

						if (notify_responsable_remove) {
							if (dados.current.info.responsable.remove.id !== '') {

								dados.current.info.responsable.remove.notification = today
								dados.current.info.responsable.remove.execution = today

							}

						}

						for await (let el_doc of files_doc_pdf) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf([])
						set_files_doc_pdf_name([])

						for await (let el_doc of files_doc_editable) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_editable([])
						set_files_doc_editable_name([])

						for await (let el_doc of files_doc_image) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'file_image', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_image([])
						set_files_doc_image_name([])

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								props.history.push(endpoints.list)
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})

		}

		set_dados(dados.current,)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqDELETE(api_crud_route, { id: dados.current.id })
						.then(() => {
							props.history.push(endpoints.list);
						})
						.catch(error => console.log(error))
				}
			})
			.catch((erro) => {
				console.log(erro)
			})

	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang } = dataset

		if (name === 'name' && 0) {
			let value_aux = {}
			let aux = dados.current.info.name.filter(e => e[lang])
			if (aux !== undefined && aux.length === 0) {
				value_aux[lang] = value
				dados.current.info.name.push(value_aux)
			}
			else {
				dados.current.info.name.forEach(el => {
					if (el[lang] !== undefined) {
						el[lang] = value
					}
				})
			}
		}

		if (name === 'external_intervention') {
			setExternalIntervention(value);
		}

		dados.current.info[name] = value

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))


	}

	const handle_change_info_translate = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if (dados.current.info[name] === undefined) {
			dados.current.info[name] = []
		}

		let value_aux = {}
		let aux = dados.current.info[name].filter(e => e[lang])
		if (aux !== undefined && aux.length === 0) {
			value_aux[lang] = value
			dados.current.info[name].push(value_aux)
		}
		else {
			dados.current.info[name].forEach(el => {
				if (el[lang] !== undefined) {
					el[lang] = value
				}
			})
		}

		if (name === 'title' && parseInt(langid) === 1) {
			dados.current.info.name = value
		}

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handleSingleCheckActive = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckAvaiable = () => {
		console.log('dados.current.info', dados.current.info)
		set_dados(dados.current.info.avaiable = !dados.current.info.avaiable)
	}

	const handleSingleCheckAproval = () => {

		set_document_state_aprove(!document_state_aprove)

	}

	const change_active_settings = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.settings === undefined) {
			dados.current.info.settings = {}
		}

		set_dados(dados.current.info.settings[name] = value)

		const parsedValue = parseInt(value, 10);

		if (parsedValue === 13) {
			setManutencao(true);
		} else if (parsedValue === 12) {
			setManutencao(false);
		}

	}

	const change_active_responsable = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.responsable === undefined) {
			dados.current.info.responsable = {}
		}

		if (name === 'edit') {
			set_notify_responsable_edit(true)
		}
		else if (name === 'aproval') {
			set_notify_responsable_aproval(true)
		}
		else if (name === 'remove') {
			set_notify_responsable_remove(true)
		}

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: value,
			name: '',
			notification: '',
			execution: ''
		}
		if (Array.isArray(aux_entity) && aux_entity.length > 0) {
			console.log(aux_entity[0])
			aux.name = aux_entity[0].label
		}

		set_dados(dados.current.info.responsable[name] = aux)

		console.log('dados.current.info.responsable', dados.current.info.responsable)

	}

	const open_link = (url) => {
		window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const handle_change_tree_editable = (tD, order, langid) => {

		treeDataEditable[order][langid] = tD

		let aux = []
		treeDataEditable[order][langid].forEach((el) => {
			dados.current.info.file.editable.forEach((el_2) => {
				if (el.id_doc === el_2.id)
					aux.push(el_2)
			})
		});
		set_dados(dados.current.info.file.editable = aux)
		setTreeDataEditable(treeDataEditable)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_editable = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataEditable[order][langid].filter(v => v.id !== id)
					treeDataEditable[order][langid] = treeAux
					setTreeDataEditable(treeDataEditable)

					let aux = []
					dados.current.info.file.editable.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.editable = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_editable = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataEditable[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.editable.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataEditable(treeDataEditable)
		set_dados(dados.current.info,)
	}

	const onChangeHandlerFilesEditable = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_editable_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_editable_name(aux2)

				let aux_doc = treeDataEditable
				if (treeDataEditable[order] === undefined)
					treeDataEditable[order] = []
				if (treeDataEditable[order][langid] === undefined)
					treeDataEditable[order][langid] = []
				let i = treeDataEditable[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataEditable(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_editable
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_editable(files_aux)
	}

	const handle_change_tree_pdf = (tD, order, langid) => {

		treeDataPDF[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}
		else {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataPDF[order][langid].filter(v => v.id !== id)
					treeDataPDF[order][langid] = treeAux
					setTreeDataPDF(treeDataPDF)

					let aux = []
					if (langid === '1') {
						dados.current.content[order].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order].media.doc = aux)
					}
					else {
						dados.current.content[order]['language'][langid].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
					}

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataPDF[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.content[order].media.doc.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataPDF(treeDataPDF)
		set_dados(dados.current.content[order],)
	}

	const onChangeHandlerFilesPDF = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_pdf_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_pdf_name(aux2)

				let aux_doc = treeDataPDF
				if (treeDataPDF[order] === undefined)
					treeDataPDF[order] = []
				if (treeDataPDF[order][langid] === undefined)
					treeDataPDF[order][langid] = []
				let i = treeDataPDF[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataPDF(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_pdf
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf(files_aux)
	}

	const uploadFilesDoc = async (files, order, type, langid, lang) => {
		let aux = []
		for await (let element of files) {
			aux.push(element)

			await uploadFile(element, order, type, langid, lang)
		}
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'maintenance')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/maintenance/');

		let res = await reqFILE(`${api_crud_base}/multimedia/file`, formData)

		var today_file = new Date()
		let i = Date.now()

		if (dados.current.info.file === undefined) {
			dados.current.info.file = {}
		}
		if (!Array.isArray(dados.current.info.file[type])) {
			dados.current.info.file[type] = []
		}

		if (type === 'editable') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}
		else if (type === 'pdf') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}
		else if (type === 'file_image') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}

		await reqPUT(api_crud_route, dados.current)

		return true

	}

	const handle_change_tree_image = (tD, order, langid) => {

		treeDataImage[order][langid] = tD

		let aux = []
		treeDataImage[order][langid].forEach((el) => {
			dados.current.info.file.image.forEach((el_2) => {
				if (el.id_doc === el_2.id)
					aux.push(el_2)
			})
		});
		set_dados(dados.current.info.file.image = aux)
		setTreeDataImage(treeDataImage)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_image = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataImage[order][langid].filter(v => v.id !== id)
					treeDataImage[order][langid] = treeAux
					setTreeDataImage(treeDataImage)

					let aux = []
					dados.current.info.file.image.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.image = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_image = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataImage[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.image.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataImage(treeDataImage)
		set_dados(dados.current.info,)
	}

	const onChangeHandlerFilesFileImage = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_image_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_image_name(aux2)

				let aux_doc = treeDataImage
				if (treeDataImage[order] === undefined)
					treeDataImage[order] = []
				if (treeDataImage[order][langid] === undefined)
					treeDataImage[order][langid] = []
				let i = treeDataImage[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataImage(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_image(files_aux)
	}

	useEffect(() => {
		if (dados?.current?.info?.external_intervention !== undefined && dados?.current?.info?.external_intervention !== null) {
			setExternalIntervention(dados.current.info.external_intervention);
		}
	}, [dados]);

	const getRepairTypeLabel = (type) => {
		if (type === "13") return "C";
		if (type === "12") return "P";
		return type || '—';
	};

	const handleAddMaintenanceOrder = async () => {
		let aux = {
			id: '',
			info: {
				active: false,
				avaiable: false,
				type: 'order',
				companycode: "2024000",
				equipment: {
					id: selectedEquipment.id,
					name: selectedEquipment.name,
					cod: selectedEquipment.cod,
					brand: selectedEquipment.brand,
					model: selectedEquipment.model,
					serie: selectedEquipment.serie,
					local: selectedEquipment.local,
				},
				external_intervention: dados.current.external_intervention,
				problem_description: dados.current.info.problem_description || [],
				loc_problem: dados.current.info.loc_problem || [],
				responsable: {
					edit: dados.current.info.responsable?.edit || {},
					aproval: dados.current.info.responsable?.aproval || {},
					remove: dados.current.info.responsable?.remove || {},
				},
				settings: {
					...dados.current.info.settings,
					repair_type: dados.current.info.settings?.repair_type || '',
					data_inicio: dados.current.info.settings?.data_inicio || '',
					deadline: dados.current.info.settings?.deadline || '',
					det_date: dados.current.info.settings?.det_date || '',
					activity_number: dados.current.info.settings?.activity_number || '',
					activity: dados.current.info.settings?.activity || '',
					procedure: dados.current.info.settings?.procedure || '',
					element: dados.current.info.settings?.element || '',
					periodicity: dados.current.info.settings?.periodicity || '',
				}
			},
		};

		try {
			let res;

			if (isEditing) {
				aux.id = editItemId;
				res = await reqPUT(`${api_crud_base}/intranet/maintenance`, aux);

				get_info(aux.info.equipment.id);
				setRefresh(prev => prev + 1);

			} else {
				res = await reqPOST(`${api_crud_base}/intranet/maintenance`, aux);

				get_info(aux.info.equipment.id);
				setRefresh(prev => prev + 1);
			}

			if (res.status === 200) {
				const savedOrder = res.data || aux;

				// set_maintenance_orders(prev =>
				// 	isEditing
				// 		? prev.map(order => order.id === savedOrder.id ? savedOrder : order)
				// 		: [...prev, savedOrder]
				// );

				setIsEditing(false);
				setEditItemId(null);

				setModal(false);

			} else {
				console.error("API Error", res);
				// Optionally: Show user-facing error
			}

		} catch (err) {
			console.error("Error saving maintenance order:", err);
			// Optionally: Show user-facing error
		}

		resetModalFields();
	};

	const handleEditMaintenanceOrder = (item) => {
		setIsEditing(true);

		setEditItemId(item.id);
		setSelectedEquipment(item.info.equipment);

		dados.current = item;
		if (item.info.settings.repair_type === '13') {
			setManutencao(true);
		} else if (item.info.settings.repair_type === '12') {
			setManutencao(false);
		}

		setModal(true);
		setRefresh(prev => prev + 1);

		console.log('Editing item:', item);
	};

	const handleRemoveMaintenanceOrder = async (orderId) => {
		try {

			await Swal.fire({
				title: language[lang].delete_title,
				text: language[lang].delete_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].delete_confirm,
				cancelButtonText: language[lang].delete_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {

						const res = await reqDELETE(`${api_crud_base}/intranet/maintenance`, orderId);

						if (res?.status === 200) {

							setModal(false);
							setIsEditing(false);
							setEditItemId(null);

							get_info(selectedEquipment);
							setRefresh(prev => prev + 1);

						} else {
							console.error("API Error while deleting", res);
						}
					}
				})

		} catch (err) {
			console.error("Error removing maintenance order:", err);
		}
	};

	const resetModalFields = () => {
		dados.current = {
			info: {
				settings: {
					repair_type: '',
					data_inicio: '',
					deadline: '',
					det_date: '',
					activity_number: '',
					activity: '',
					procedure: '',
					element: '',
					periodicity: '',
				},
				responsable: {
					edit: { id: '' },
					aproval: { id: '' },
					remove: { id: '' },
				},
				problem_description: '',
				loc_problem: '',
			}
		};
	};

	useEffect(() => {
		if (modal) {
			if (!isEditing) {
				resetModalFields();
			}
			setUpdate((prev) => prev + 1);
		}

	}, [modal]);

	return isloading ?
		<Loader />
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<div className="container">
						<h2 className="dash-title">{language[lang].component}</h2>
						<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
					</div>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className='card'>
									<div className="card-header border-0 d-flex justify-content-sm-between">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">
												{(dados.current?.info?.name || '').length > 0
													? dados.current.info.name
													: language[lang].component_new}
											</h3>
										</div>
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<li key={k_lang} className="nav-item d-none">
																	<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
																</li>
															)
														})
														:
														null
												}
											</ul>
										</div>
									</div>

									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<div className='tab-content'>
													{
														content_language.length > 0 ?
															content_language.map((el_lang, k_lang) => {
																return (
																	<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">
																		<div className="row mb-4">
																			<div className="row mb-4">
																				<div className="col-md-8">
																					{selectedEquipment && (
																						<div className="border rounded p-3 bg-light">
																							<h6 className="fw-bold mb-4">🔍 {language[lang].field_details}</h6>
																							<p><strong>{language[lang].field_cod}:</strong> {dados.current?.info.tag}</p>
																							<p><strong>{language[lang].field_label}:</strong> {dados.current?.info?.name}</p>
																							<p><strong>{language[lang].field_brand}:</strong> {dados.current?.info?.settings.storage_brand}</p>
																							<p><strong>{language[lang].field_model}:</strong> {dados.current?.info?.settings.storage_model}</p>
																							<p><strong>{language[lang].field_serie}:</strong> {dados.current?.info?.settings.storage_serie}</p>
																							<p><strong>{language[lang].field_local}:</strong> {dados.current?.info?.settings.storage_local}</p>
																							<p><strong>{language[lang].field_fab_year}:</strong> {dados.current?.info?.settings.storage_fab_year}</p>
																							<p><strong>{language[lang].field_valor_de_aquisicao}:</strong> {dados.current?.info?.settings.valor_de_aquisicao}€</p>
																						</div>
																					)}
																				</div>
																			</div>
																			<div className="row mb-3">
																				<div className="card-title m-0 mt-4 d-flex justify-content-between align-items-center">
																					<div></div>

																					{/* Add Button */}
																					<div>
                                    													<label>&nbsp;</label>
																						<button
																							type="button"
                                        													className='btn rounded-pill btn-sm py-1 px-4 btn-outline-secondary'
																							onClick={() => setModal(true)}
																						>
																							{language[lang].add_new}
																						</button>
																					</div>
																				</div>
																			</div>

																			<div className="row mb-4">
																				<div className='col-12 col-md-4'></div>
																				<div className='col-12 col-md-8 d-flex'>
																					{/* Year Filter */}
																					{
																					years_actives.current !== undefined && years_actives.current !== null ?
																						<div className='col me-3'>
																							<label>
																								{language[lang].ano}
																							</label>
																							<select
																								className="form-select form-control mb-4 mb-lg-0 rounded-0"
																								value={filterYear}
																								onChange={(e) => setFilterYear(e.target.value)}
																							>
																								<option value="">{language[lang].field_choose}</option>
																								{years_actives.current.map((year) => (
																									<option key={year} value={year}>{year}</option>
																								))}
																							</select>
																						</div>
																					:
																						null
																					}

																					{/* Month Filter */}
																					<div className='col me-3'>
																						<label>
																							{language[lang].mes}
																						</label>
																						<select
																							className="form-select form-control mb-4 mb-lg-0 rounded-0"
																							value={filterMonth}
																							onChange={(e) => setFilterMonth(e.target.value)}
																						>
																							<option value="">{language[lang].field_choose}</option>
																							{MONTH_NAMES.map((monthName, i) => (
																								<option key={i + 1} value={i + 1}>{monthName}</option>
																							))}
																						</select>
																					</div>

																					{/* Clear Month Button */}
																					<div className='col'>
																						<label>&nbsp;</label>
																						<button
																							type="button"
                                        													className='btn btn-primary w-100'
																							onClick={() => {
																								setFilterMonth('');
																								setFilterYear(new Date().getFullYear().toString());
																							}}

																						>
																							{language[lang].field_clean}
																						</button>
																					</div>
																				</div>
																			</div>

																			{/* Table */}
																			<div className="row mb-4">
																				{maintenance_orders.current !== null &&
																					maintenance_orders.current.some(order => order.info.equipment?.id === selectedEquipment.id) && (
																						<div className={"div-table"}>
																							<div className='table-body table-responsive'>
																								<table className="table table-hover table-bordered align-middle">
																									<thead className="text-center align-middle">
																										<tr>
																											<th className='p-3'>{language[lang].man_cod}</th>
																											<th className='p-3'>{language[lang].man_aprovador}</th>
																											<th className='p-3'>{language[lang].man_executor}</th>
																											<th className='p-3'>{language[lang].man_inicio}</th>
																											<th className='p-3'>{language[lang].man_prazo}</th>
																											<th className='p-3'>{language[lang].man_tipo}</th>
																											<th className='p-3'></th>
																										</tr>
																									</thead>
																									<tbody>
																										{maintenance_orders.current
																											.filter(order => order.info.equipment?.id === selectedEquipment.id)
																											.filter(order => {
																												const startDate = order.info.settings?.data_inicio;
																												if (!startDate) return false;
																												const date = new Date(startDate);
																												const yearMatches = filterYear ? date.getFullYear() === parseInt(filterYear) : true;
																												const monthMatches = filterMonth ? date.getMonth() + 1 === parseInt(filterMonth) : true;
																												return yearMatches && monthMatches;
																											})
																											.map((item) => (
																												<tr key={item.id}>
																													<td className='text-center'>{item.id || '—'}</td>
																													<td>{item.info.responsable?.aproval?.name || '—'}</td>
																													<td>{item.info.responsable?.edit?.name || '—'}</td>
																													<td className='text-center'>{item.info.settings?.data_inicio || '—'}</td>
																													<td className='text-center'>{item.info.settings?.deadline || '—'}</td>
																													<td className='text-center'>{getRepairTypeLabel(item.info.settings?.repair_type)}</td>
																													<td className='text-center'>
																														<span>
																															<button type="button" className='me-3' onClick={() => handleEditMaintenanceOrder(item)}>
																																<i className="bi bi-pencil"></i>
																															</button>
																														</span>
																														<span>
																															<button type="button" onClick={() => handleRemoveMaintenanceOrder(item)}>
																																<i className="bi bi-trash"></i>
																															</button>
																														</span>
																													</td>
																												</tr>
																											))}
																									</tbody>
																								</table>
																							</div>
																						</div>
																					)}
																			</div>
																		</div>

																		{modal && (
																			<div className="modal fade show d-block" tabIndex="-1" role="dialog">
																				<div className="modal-dialog modal-xl modal-dialog-centered" role="document" style={{ marginLeft: '20%' }}>
																					<div className="modal-content rounded-4 shadow">
																						<div className="modal-header">
																							<h5 className="modal-title">{language[lang].add_new}</h5>
																							<button type="button" className="btn-close" onClick={() => setModal(false)}></button>
																						</div>

																						<div className="modal-body">
																							<div className="row mb-4">
																								<div className="col-4 col-md-4">
																									<label className="fs-6 fw-bold mb-2">{language[lang].tipo_manutencao}</label>
																									<select
																										name="repair_type"
																										className="form-select form-control mb-4 mb-lg-0 rounded-0"
																										onChange={change_active_settings}
																										value={dados?.current?.info?.settings?.repair_type !== undefined && dados?.current?.info?.settings?.repair_type !== null ? dados.current.info.settings.repair_type : ''}
																									>
																										<option value="">{language[lang].field_choose}</option>
																										{
																											repair_type.current !== undefined && repair_type.current !== null ?
																												repair_type.current.map((el_dsl, k_dsl) => (
																													<option key={k_dsl} value={el_dsl.id}>
																														{el_dsl.label}
																													</option>
																												))
																												:
																												null
																										}
																									</select>
																								</div>

																								<div className="col-12 col-md-4">
																									<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable}</label>
																									<select
																										name="edit"
																										className="form-select form-control mb-4 mb-lg-0 rounded-0"
																										onChange={change_active_responsable}
																										value={dados?.current?.info?.responsable?.edit?.id !== undefined && dados?.current?.info?.responsable?.edit?.id !== null ? dados.current.info.responsable.edit?.id : ''}
																									>
																										<option value="">{language[lang].field_choose_respnsable}</option>
																										{
																											entities_list.current !== undefined && entities_list.current !== null ?
																												entities_list.current.map((el_el, k_el) => (
																													<option key={k_el} value={el_el.id}>
																														{el_el.label}
																													</option>
																												))
																												:
																												null
																										}
																									</select>
																								</div>
																							</div>

																							<div className="row mb-4">
																								<div className="col-4 col-md-4">
																									<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_data_inicio}</label>
																									<input
																										type="date"
																										name="data_inicio"
																										data-langid={el_lang.id}
																										data-lang={el_lang.code}
																										defaultValue={dados.current.info.settings.data_inicio}
																										onChange={(e) => change_active_settings(e)}
																										className="form-control mb-4 rounded-0" />
																								</div>

																								<div className="col-4 col-md-4">
																									<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_deadline}</label>
																									<input
																										type="date"
																										name="deadline"
																										data-langid={el_lang.id}
																										data-lang={el_lang.code}
																										defaultValue={dados.current.info.settings.deadline}
																										onChange={(e) => change_active_settings(e)}
																										className="form-control mb-4 rounded-0" />
																								</div>
																							</div>

																							{/* Manutenção Curativa*/}
																							{manutencao !== null && manutencao === true && (
																								<div className="row mb-4">
																									<div className="col-6">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].problem_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																										<textarea
																											type="text"
																											rows="4"
																											name="problem_description"
																											data-langid={el_lang.id}
																											data-lang={el_lang.code}
																											defaultValue={translate(dados.current.info.problem_description, el_lang.code)}
																											onChange={(e) => handle_change_info_translate(e)}
																											className="form-control rounded-0"
																										/>
																									</div>

																									<div className="col-12 col-md-6">
																										<div className="div-doc">
																											<label className="col-form-label fw-bold fs-6">{language[lang].field_occurrence_image}</label>

																											<div className="dropzone-panel mb-lg-0 mb-2">
																												<div className="div-form-input col-12 custom-file">
																													<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-image-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																													<input
																														id={"input-files-image-" + 0 + '-' + el_lang.id}
																														type="file"
																														// accept="application/pdf"
																														data-order={0}
																														data-langid={el_lang.id}
																														data-lang={el_lang.code}
																														data-type={'doc'}
																														className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																														onChange={onChangeHandlerFilesFileImage}
																														multiple
																													/>
																												</div>
																											</div>

																											<div className="row">
																												{
																													treeDataImage[0] !== undefined && treeDataImage[0][el_lang.id] !== undefined ?
																														<SortableTree
																															isVirtualized={false}
																															treeData={treeDataImage[0][el_lang.id]}
																															maxDepth={1}
																															canDrag={false}
																															//onChange={() => console.log('onChange')}
																															onChange={treeDataImage => handle_change_tree_image(treeDataImage, 0, el_lang.id)}
																															getNodeKey={({ node }) => node.id}
																															generateNodeProps={extendedNode => ({
																																title: (
																																	<>
																																		{extendedNode.node.title}
																																		<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_image} />
																																	</>
																																),
																																buttons: [
																																	<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																																	<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																																	<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																																	<button type="button" onClick={() => remove_element_tree_image(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																																],
																															})}
																														/>
																														:
																														''
																												}
																											</div>
																										</div>
																									</div>
																								</div>
																							)}

																							{manutencao !== null && manutencao === true && (
																								<div className="row mb-4">
																									<div className="col-6 mb-4">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].problem_loc} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																										<textarea
																											type="text"
																											rows="4"
																											name="loc_problem"
																											data-langid={el_lang.id}
																											data-lang={el_lang.code}
																											defaultValue={translate(dados.current.info.loc_problem, el_lang.code)}
																											onChange={(e) => handle_change_info_translate(e)}
																											className="form-control rounded-0"
																										/>
																									</div>

																									<div className="col-4 col-md-4">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_det_date}</label>
																										<input
																											type="date"
																											name="det_date"
																											data-langid={el_lang.id}
																											data-lang={el_lang.code}
																											defaultValue={dados.current.info.settings.det_date}
																											onChange={(e) => change_active_settings(e)}
																											className="form-control mb-4 rounded-0" />
																									</div>
																								</div>
																							)}

																							{manutencao !== null && manutencao === true && (
																								<div className="row mb-4">
																									<div className="col-12 col-md-6 d-none">
																										<div className="div-doc">
																											<label className="col-form-label fw-bold fs-6">{language[lang].editable_documents}</label>

																											<div className="dropzone-panel mb-lg-0 mb-2">
																												<div className="div-form-input col-12 custom-file">
																													<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-editable-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																													<input
																														id={"input-files-editable-" + 0 + '-' + el_lang.id}
																														type="file"
																														// accept="application/pdf"
																														data-order={0}
																														data-langid={el_lang.id}
																														data-lang={el_lang.code}
																														data-type={'doc'}
																														className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																														onChange={onChangeHandlerFilesEditable}
																														multiple
																													/>
																												</div>
																											</div>

																											<div className="row">
																												{
																													treeDataEditable[0] !== undefined && treeDataEditable[0][el_lang.id] !== undefined ?
																														<SortableTree
																															isVirtualized={false}
																															treeData={treeDataEditable[0][el_lang.id]}
																															maxDepth={1}
																															canDrag={false}
																															//onChange={() => console.log('onChange')}
																															onChange={treeDataEditable => handle_change_tree_editable(treeDataEditable, 0, el_lang.id)}
																															getNodeKey={({ node }) => node.id}
																															generateNodeProps={extendedNode => ({
																																title: (
																																	<>
																																		{extendedNode.node.title}
																																		<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_editable} />
																																	</>
																																),
																																buttons: [
																																	<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																																	<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																																	<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																																	<button type="button" onClick={() => remove_element_tree_editable(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																																],
																															})}
																														/>
																														:
																														''
																												}
																											</div>
																										</div>
																									</div>

																									<div className="col-12 col-md-6  d-none">
																										<div className="div-doc">
																											<label className="col-form-label fw-bold fs-6">{language[lang].pdf_documents}</label>

																											<div className="dropzone-panel mb-lg-0 mb-2">
																												<div className="div-form-input col-12 custom-file">
																													<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-pdf-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																													<input
																														id={"input-files-pdf-" + 0 + '-' + el_lang.id}
																														type="file"
																														accept="application/pdf"
																														data-order={0}
																														data-langid={el_lang.id}
																														data-lang={el_lang.code}
																														data-type={'doc'}
																														className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																														onChange={onChangeHandlerFilesPDF}
																														multiple
																													/>
																												</div>
																											</div>

																											<div className="row">
																												{
																													treeDataPDF[0] !== undefined && treeDataPDF[0][el_lang.id] !== undefined ?
																														<SortableTree
																															isVirtualized={false}
																															treeData={treeDataPDF[0][el_lang.id]}
																															maxDepth={1}
																															canDrag={false}
																															//onChange={() => console.log('onChange')}
																															onChange={treeDataPDF => handle_change_tree_pdf(treeDataPDF, 0, el_lang.id)}
																															getNodeKey={({ node }) => node.id}
																															generateNodeProps={extendedNode => ({
																																title: (
																																	<>
																																		<span>{extendedNode.node.title}</span>
																																		<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_pdf} />
																																	</>
																																),
																																buttons: [
																																	<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																																	<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																																	<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																																	<button type="button" onClick={() => remove_element_tree_pdf(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																																],
																															})}
																														/>
																														:
																														''
																												}
																											</div>
																										</div>
																									</div>
																								</div>
																							)}

																							{/* Manutenção Preventiva */}
																							{manutencao !== null && manutencao === false && (
																								<div className="row mb-4">
																									<div className="col-4 col-md-4">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_activity_number}</label>
																										<input
																											type="number"
																											name="activity_number"
																											data-langid={el_lang.id}
																											data-lang={el_lang.code}
																											defaultValue={dados.current.info.settings.activity_number}
																											placeholder={language[lang].field_activity_number_placeholder}
																											onChange={(e) => change_active_settings(e)}
																											className="form-control rounded-0" />
																									</div>

																									<div className="col-4 col-md-4">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_activity}</label>
																										<input
																											type="text"
																											name="activity"
																											data-langid={el_lang.id}
																											data-lang={el_lang.code}
																											defaultValue={dados.current.info.settings.activity}
																											placeholder={language[lang].field_activity_placeholder}
																											onChange={(e) => change_active_settings(e)}
																											className="form-control rounded-0" />
																									</div>
																								</div>
																							)}

																							{manutencao !== null && manutencao === false && (
																								<div className="row mb-4">
																									<div className="col-4 col-md-4">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_procedure}</label>
																										<input
																											type="text"
																											name="procedure"
																											data-langid={el_lang.id}
																											data-lang={el_lang.code}
																											defaultValue={dados.current.info.settings.procedure}
																											placeholder={language[lang].field_procedure_placeholder}
																											onChange={(e) => change_active_settings(e)}
																											className="form-control rounded-0" />
																									</div>
																									<div className="col-4 col-md-4">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_element}</label>
																										<input
																											type="text"
																											name="element"
																											data-langid={el_lang.id}
																											data-lang={el_lang.code}
																											defaultValue={dados.current.info.settings.element}
																											placeholder={language[lang].field_element_placeholder}
																											onChange={(e) => change_active_settings(e)}
																											className="form-control rounded-0" />
																									</div>
																									<div className="col-4 col-md-4">
																										<label className="fs-6 fw-bold mb-2">{language[lang].tipo_manutencao}</label>
																										<select
																											name="periodicity"
																											className="form-select form-control mb-4 mb-lg-0 rounded-0"
																											onChange={change_active_settings}
																											value={dados?.current?.info?.settings?.periodicity !== undefined && dados?.current?.info?.settings?.periodicity !== null ? dados.current.info.settings.periodicity : ''}
																										>
																											<option value="">{language[lang].field_choose}</option>
																											{
																												periodicity.current !== undefined && periodicity.current !== null ?
																													periodicity.current.map((el_dsl, k_dsl) => (
																														<option key={k_dsl} value={el_dsl.id}>
																															{el_dsl.label}
																														</option>
																													))
																													:
																													null
																											}
																										</select>
																									</div>
																								</div>
																							)}

																							<div className="row mb-4">
																								<div className="col-12 col-md-4">
																									<label className="fs-6 fw-bold mb-2">{language[lang].field_aproval_responsable}</label>
																									<select
																										name="aproval"
																										className="form-select form-control mb-4 mb-lg-0 rounded-0"
																										onChange={change_active_responsable}
																										value={dados?.current?.info?.responsable?.aproval?.id !== undefined && dados?.current?.info?.responsable?.aproval?.id !== null ? dados.current.info.responsable.aproval?.id : ''}
																									>
																										<option value="">{language[lang].field_choose_respnsable}</option>
																										{
																											entities_list.current !== undefined && entities_list.current !== null ?
																												entities_list.current.map((el_el, k_el) => (
																													<option key={k_el} value={el_el.id}>
																														{el_el.label}
																													</option>
																												))
																												:
																												null
																										}
																									</select>
																								</div>
																								<div className="col-12 col-md-4 d-none">
																									<label className="fs-6 fw-bold mb-2">{language[lang].field_remove_responsable}</label>
																									<select
																										name="remove"
																										className="form-select form-control mb-4 mb-lg-0 rounded-0"
																										onChange={change_active_responsable}
																										value={dados?.current?.info?.responsable?.remove?.id !== undefined && dados?.current?.info?.responsable?.remove?.id !== null ? dados.current.info.responsable.remove?.id : ''}
																									>
																										<option value="">{language[lang].field_choose_respnsable}</option>
																										{
																											entities_list.current !== undefined && entities_list.current !== null ?
																												entities_list.current.map((el_el, k_el) => (
																													<option key={k_el} value={el_el.id}>
																														{el_el.label}
																													</option>
																												))
																												:
																												null
																										}
																									</select>
																								</div>
																							</div>

																						</div>

																						<div className="modal-footer">
																							<button type="button" className="btn btn-default" onClick={() => { setModal(false); }}>
																								{language[lang].close}
																							</button>
																							<button
																								type="button"
																								onClick={handleAddMaintenanceOrder}
																								className="btn btn-default"
																							>
																								{language[lang].add}
																							</button>
																						</div>
																					</div>
																				</div>
																				<div className="modal-backdrop fade show"></div>
																			</div>
																		)}

																	</div>
																)
															})
															:
															null
													}
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer d-none'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
									</Link>
								</li>
								{/* 
								<li className={"nav-item" + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								*/}
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
